import ClassificationDTO from '../classification/classificationDTO';
import IdListDTO from '../IdListDTO';
import ResourceLinkDTO from '../resourceLinkDTO';
import StringValueDTO from '../stringValue/stringValueDTO';
import { Asset_TranslationDTO } from './asset_TranslationDTO';

export default class AssetDTO {
  assetId: number;

  authSchemaId?: number;

  code: string;

  commentTrailId?: number;

  externalId?: string;

  auditTrailId: number;

  ownerId?: string;

  ownerRoleId?: string;

  state: number;

  listId?: number;

  type: number;

  trans: Asset_TranslationDTO[];

  links?: ResourceLinkDTO[];

  containers?: AssetDTO[];

  normIds?: IdListDTO;

  tagIds?: IdListDTO;

  classifications?: ClassificationDTO[];

  lifeCycleStart?: string;

  lifeCycleEnd?: string;

  website?: string | null;

  contactEmail?: string | null;

  primaryContainerId?: number;

  classificationGroups?: IdListDTO;

  locationId?: number;

  location?: StringValueDTO;

  retentionPeriodId?: number;

  retentionPeriod?: StringValueDTO;

  constructor() {
    this.assetId = 0;
    this.code = '';
    this.auditTrailId = 0;
    this.state = 0;
    this.type = 0;
    this.trans = [];
  }
}

export class AssetProcessDTO {
  assetId: number;

  processId: number;

  constructor(_assetId: number = -1, _processId: number = -1) {
    this.assetId = _assetId;
    this.processId = _processId;
  }
}

export class AssetRiskDTO {
  assetId: number;

  riskId: number;

  constructor(_assetId: number = -1, _riskId: number = -1) {
    this.assetId = _assetId;
    this.riskId = _riskId;
  }
}
